import { Button, Center } from "@mantine/core";

export default function PrevNextFinish(props: any) {
  const {
    paginate,
    step,
    lastStep,
    queryArgs,
    challengeContext,
    privateUsernameHint,
    selectedLocationHint,
    asset,
    ci,
    privateUsername,
    selectedLocation,
    setAsset,
    makeUrl,
    formIsValid,
  } = props;
  return (
    <Center>
      <Button
        variant="outline"
        radius="xl"
        mt="xl"
        mr="xl"
        onClick={() => {
          paginate(-1);
        }}
        disabled={step < 1}
      >
        Back
      </Button>
      {step >= lastStep && (
        <Button
          disabled={challengeContext === "" && queryArgs.get("mode") === "auth"}
          variant="outline"
          radius="xl"
          mt="xl"
          type="submit"
          onClick={async (e: any) => {
            if ((queryArgs.get("mode") as any) === "asset") {
              e.preventDefault();
              if (asset.asset) {
                await ci.setAsset(
                  privateUsername,
                  selectedLocation.lat,
                  selectedLocation.lng,
                  JSON.stringify(asset)
                );
              } else {
                const asset = JSON.parse(
                  await ci.getAsset(
                    privateUsername,
                    selectedLocation.lat,
                    selectedLocation.lng
                  )
                );
                setAsset({ ...asset });
              }
              window.parent.postMessage({ ...asset }, "*");
              return false;
            } else if ((queryArgs.get("mode") as any) === "auth") {
              const challenge_context = JSON.parse(challengeContext);
              const client_id = queryArgs.get("client_id");
              const res = await fetch(makeUrl(queryArgs.get("next")), {
                method: "POST",
                body: JSON.stringify({
                  hints: {
                    private_username_hint: privateUsernameHint,
                    selected_location_hint: selectedLocationHint,
                  },
                  challenge_context: challenge_context,
                  client_id: client_id,
                }),
                headers: { "Content-type": "application/json" },
              });
              const result = await res.json();
              if (result.status === true) {
                if ((queryArgs.get("openid") as any) === "1") {
                  const redirect_uri = queryArgs.get("redirect_uri");
                  const state = queryArgs.get("state");
                  window.location.href = `${redirect_uri}?code=${result.auth_code}&state=${state}`;
                } else {
                  window.location.href = makeUrl("/dashboard");
                }
              }
              return false;
            }
          }}
        >
          Finish
        </Button>
      )}
      {step < lastStep && (
        <Button
          variant="outline"
          radius="xl"
          mt="xl"
          onClick={() => {
            paginate(1);
          }}
          disabled={
            (step === 0 && !formIsValid) ||
            (step === 1 &&
              (privateUsername.length === 0 ||
                (queryArgs.get("stage") === "register" &&
                  privateUsernameHint.length === 0))) ||
            (step === 2 &&
              (!selectedLocation.lat ||
                (queryArgs.get("stage") === "register" &&
                  selectedLocationHint.length === 0)))
          }
        >
          Next
        </Button>
      )}
    </Center>
  );
}
